export const TEXT = {
  search: {
    placeholder:
      "Search by keywords, diseases, drugs, MeSH terms, NCT number, drug name, investigator",
  },
  datasets: {
    searchPlaceholder: "Search",
  },
};
